<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-toc-title">Table of Contents</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Acknowledgments#uzpynFK6Vo38YHWpUbZEfK6">ACKNOWLEDGMENTS</a>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_01#u9kHI5QBZoMQDOLrRaN6tX8">Chapter One</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_02#uAweJHGLNOoQAAYtvs78rTA">Chapter Two</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_03#upkGLCWBSvhHu57qvltMsN4">Chapter Three</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_04#ufhEPQpflmUlChxBvAaOJeB">Chapter Four</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_05#uj6x4TIqZdrrZwXPkWC2YxA">Chapter Five</a>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_06#uRbEqlFVXZQzrGJqzNPLrJE">Chapter Six</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_07#uvn5RYVlt27f7yEjVJ6xdLB">Chapter Seven</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_08#uY2HJdlQoQLBLGCaj23uHQ2">Chapter Eight</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_09#u7mwalYPM8rshzavJiRlDEB">Chapter Nine</a>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_10#uj9b375jVuEmQcubDOSZQ64" title="Link target outside of Sample">Chapter Ten</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_11#uUH6ObgnVBxiVAZdEAOBWZ7" title="Link target outside of Sample">Chapter Eleven</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_12#uGounmuvqSW64QA9ltpjct5" title="Link target outside of Sample">Chapter Twelve</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_13#usxCAelED8qjykaN6GIRjz8" title="Link target outside of Sample">Chapter Thirteen</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_14#uZwshxipdA8PcUND5VThvA4" title="Link target outside of Sample">Chapter Fourteen</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_15#uLTXjH3GSK67sDgQWBsYmV5" title="Link target outside of Sample">Chapter Fifteen</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_16#uwYY7b8ktanw9Yf4EKbksM7" title="Link target outside of Sample">Chapter Sixteen</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_17#uEpq9m4haVWOyktzFT3B9i9" title="Link target outside of Sample">Chapter Seventeen</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_18#upGP5a9T9OgS3MJeMSUemsD" title="Link target outside of Sample">Chapter Eighteen</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_19#u9MMzulPUyOwyVbPcGtJeK2" title="Link target outside of Sample">Chapter Nineteen</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_20#uEd5MScJx7sPcoYVad95Na4" title="Link target outside of Sample">Chapter Twenty</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_21#uJdLnzeo6zWBNLODPnrDIbF" title="Link target outside of Sample">Chapter Twenty-One</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_22#uHZGyFBDjlfqC2WuwHQPTZ9" title="Link target outside of Sample">Chapter Twenty-Two</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_23#u6cUSiW6ogauVzOYTNXFSh9" title="Link target outside of Sample">Chapter Twenty-Three</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_24#u5h4T8SHvHtMFV29HAXFcW6" title="Link target outside of Sample">Chapter Twenty-Four</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_25#uqrW7vODbSUUgCJawpNMwCG" title="Link target outside of Sample">Chapter Twenty-Five</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_26#uewFxTcaCuQUL7rgSNAh7r9" title="Link target outside of Sample">Chapter Twenty-Six</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_27#u4tfRFcI5Hca5gnOxWa6jg7" title="Link target outside of Sample">Chapter Twenty-Seven</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_28#ufwJIKTIgikul4oUKhAglv4" title="Link target outside of Sample">Chapter Twenty-Eight</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_29#upEi6O9QLmXfEJkIBbluZNE" title="Link target outside of Sample">Chapter Twenty-Nine</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_30#utO3xSfjWzyndVx6UUQQnLC" title="Link target outside of Sample">Chapter Thirty</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_31#upyYHrFx2X2DQOx3APLitK3" title="Link target outside of Sample">Chapter Thirty-One</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_32#uDpwuuJDPvBicVQbwao9AEF" title="Link target outside of Sample">Chapter Thirty-Two</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_33#u5u9XMAbsy9rLRGPqHMVj6H" title="Link target outside of Sample">Chapter Thirty-Three</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_34#ubyyhMFQqhzoK5b6G7C4uw6" title="Link target outside of Sample">Chapter Thirty-Four</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_35#uMRCPMIf8QXvsdt6C5F8f8A" title="Link target outside of Sample">Chapter Thirty-Five</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_36#uJ6emBk7HJUdQM8NL2H9u88" title="Link target outside of Sample">Chapter Thirty-Six</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_37#uEk9iRyXWcVzPeNNzBQHCH4" title="Link target outside of Sample">Chapter Thirty-Seven</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_38#uq3THZQNdn5im28zNzb3b64" title="Link target outside of Sample">Chapter Thirty-Eight</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_39#uAhhiQeSRGoPcBr8ykgCtpG" title="Link target outside of Sample">Chapter Thirty-Nine</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_40#u2YpNphTD6EsxhnZsZlLPs2" title="Link target outside of Sample">Chapter Forty</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_41#uWiuF6Fk9mvKw62xGgKsb6B" title="Link target outside of Sample">Chapter Forty-One</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_42#uPUkGgUQbu3h8bkbFvYLKj2" title="Link target outside of Sample">Chapter Forty-Two</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_43#ui4M7rn9tL7TCU75PaRIQPD" title="Link target outside of Sample">Chapter Forty-Three</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_44#u5SAFBN6yr2BSn356PIgYd9" title="Link target outside of Sample">Chapter Forty-Four</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_45#umM9I5YcouJVd5O3iFnlYIG" title="Link target outside of Sample">Chapter Forty-Five</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_46#uFnLGsluXB9QAlddrHMJyU8" title="Link target outside of Sample">Chapter Forty-Six</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_47#uNxDThcbFYqQJsuRdKJdRVF" title="Link target outside of Sample">Chapter Forty-Seven</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_48#uOd9KQtS5n7xhd4VzRRGnrD" title="Link target outside of Sample">Chapter Forty-Eight</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_49#utWBC5nm5usAHZyWY2T87NB" title="Link target outside of Sample">Chapter Forty-Nine</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_50#uD8AFMC5uJmczlK34kGsNjD" title="Link target outside of Sample">Chapter Fifty</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_51#ujez4NghoINZRmJ4u4zSob8" title="Link target outside of Sample">Chapter Fifty-One</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_52#uwWJSCUBcHVqkbzYTsoA3v2" title="Link target outside of Sample">Chapter Fifty-Two</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_53#uo4UShdGhXCOU6UgjuJlEKB" title="Link target outside of Sample">Chapter Fifty-Three</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_54#uZJpZNL3ZHwtpfQB5uGP5Y4" title="Link target outside of Sample">Chapter Fifty-Four</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_55#uIA6kASd34qW7bmidVM7P83" title="Link target outside of Sample">Chapter Fifty-Five</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_56#uQfNtAnEmEuuimD74kuxm56" title="Link target outside of Sample">Chapter Fifty-Six</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_57#uln9mr38rqiDn69Tqkz8llB" title="Link target outside of Sample">Chapter Fifty-Seven</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_58#uy9hfAo5AH3jifGaNoAiIa6" title="Link target outside of Sample">Chapter Fifty-Eight</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_59#uuoqpysmDHs2jXcZFKsM3cA" title="Link target outside of Sample">Chapter Fifty-Nine</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_60#uamDbFPhBwTAXLATUpzU9t8" title="Link target outside of Sample">Chapter Sixty</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_61#uVk8ypSK6tsOqDS54cixpw7" title="Link target outside of Sample">Chapter Sixty-One</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_62#uuHswNeOMhCbtbpELpj78D3" title="Link target outside of Sample">Chapter Sixty-Two</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_63#u4n2fuvexHWMLTcWZed9y8H" title="Link target outside of Sample">Chapter Sixty-Three</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_64#uG3b5GXbZCHBezMAQOWzhsD" title="Link target outside of Sample">Chapter Sixty-Four</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_65#uVxTIQK2BxiiTGnJ3YWxT27" title="Link target outside of Sample">Chapter Sixty-Five</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_66#uiOsjUzvRivK2Qw92sP3YbD" title="Link target outside of Sample">Chapter Sixty-Six</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_67#uQze5aMNGmAIlaAoy2bacTH" title="Link target outside of Sample">Chapter Sixty-Seven</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_68#uLVjyQExypKwWPTpIMiUfoA" title="Link target outside of Sample">Chapter Sixty-Eight</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_69#ulwLAlG8u8XNfblZzWdT6mF" title="Link target outside of Sample">Chapter Sixty-Nine</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_70#ufaEky7wMQFY3JvzjC8mlMD" title="Link target outside of Sample">Chapter Seventy</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_71#ubNYB372pihjnSf5Ol3a6w2" title="Link target outside of Sample">Chapter Seventy-One</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_72#u6zWAv8Fy9qVzbthqHzcOm8" title="Link target outside of Sample">Chapter Seventy-Two</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_73#ulGIwUg7kODZzHhpZ7jJEA3" title="Link target outside of Sample">Chapter Seventy-Three</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_74#ue8wZoWukpA5wbeBntviIA4" title="Link target outside of Sample">Chapter Seventy-Four</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_75#uayLIv558yRzFfxuFwEsLl8" title="Link target outside of Sample">Chapter Seventy-Five</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_76#uYkF5Fs6GQ2EHdDrFhsXRW4" title="Link target outside of Sample">Chapter Seventy-Six</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_77#uXxJjguOuJThPwdqcRjFREF" title="Link target outside of Sample">Chapter Seventy-Seven</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_78#uaWUawBewdGgJGXqcCy2sK8" title="Link target outside of Sample">Chapter Seventy-Eight</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_79#u37E3UcOQR8fqcammwbtvVC" title="Link target outside of Sample">Chapter Seventy-Nine</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_80#uWj9W4MABWYTodseDwLyvu6" title="Link target outside of Sample">Chapter Eighty</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_81#uoflDrWXwXOJdrUszofeCc3" title="Link target outside of Sample">Chapter Eighty-One</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_82#uMWOpE2tpwnCeqg9nMPH8MB" title="Link target outside of Sample">Chapter Eighty-Two</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_83#ufEZ3nbgZxukYjNtWAmeCf4" title="Link target outside of Sample">Chapter Eighty-Three</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_84#uNvwLrOR5O7AlbcRrrZGpK5" title="Link target outside of Sample">Chapter Eighty-Four</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_85#uSrqKr4hn6ZiYuKDXBcGMJ3" title="Link target outside of Sample">Chapter Eighty-Five</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_86#uUXDDcMs3xSfyeJluqKym6C" title="Link target outside of Sample">Chapter Eighty-Six</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_87#u8vSXuKKoJVN8gEFEYuNf8C" title="Link target outside of Sample">Chapter Eighty-Seven</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_88#uVtvNLSWGNzM29kl5tlSzaC" title="Link target outside of Sample">Chapter Eighty-Eight</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_89#ugBkiIAAhPsHMISF53dCYF6" title="Link target outside of Sample">Chapter Eighty-Nine</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_90#ukoXfmHw79J2a9BIlMCfYBG" title="Link target outside of Sample">Chapter Ninety</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_91#u3HOKi6LNJlQUCSdi5sIP4H" title="Link target outside of Sample">Chapter Ninety-One</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_92#upqPomjplefTAdQYeAoz2d8" title="Link target outside of Sample">Chapter Ninety-Two</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_93#urashmJkLogZYyi3wERmUfE" title="Link target outside of Sample">Chapter Ninety-Three</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_94#ueaEHrVrLXIr6JAfviCEljG" title="Link target outside of Sample">Chapter Ninety-Four</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_95#u3ZCXPFxWnpLDP8H6XkYqh5" title="Link target outside of Sample">Chapter Ninety-Five</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_96#u4Ik7tjL7qpvX2YxqebaEtD" title="Link target outside of Sample">Chapter Ninety-Six</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_97#uhuxETdkKg8kRouClTUyms7" title="Link target outside of Sample">Chapter Ninety-Seven</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_98#uqTff5OsMMKOAZk3qS7Vr8G" title="Link target outside of Sample">Chapter Ninety-Eight</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_99#urqiDoRAgxeZqAhHpKZT8E7" title="Link target outside of Sample">Chapter Ninety-Nine</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?faa4245e